import React, { FC, useContext } from 'react';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import CardBox from '../CardBox';
import SwitchDate, { IndexTimeActive } from '../SwitchDate';
import { Dropdown } from '@maxtropy/components';
import { DateContext } from '../../index';
import EnergyStats from './EnergyStats';
import DeviceTypePie from './DeviceTypePie';
import EnergyTrend from './EnergyTrend';

const LeftBox: FC = () => {
  const { activeKey, selectedDate, setActiveKey, setSelectedDate } = useContext(DateContext);

  return (
    <div className={styles.left_wrapper}>
      {/* 用能统计 */}
      <div className={styles.section_energy_stats}>
        <CardBox
          title="用能统计"
          extraContent={
            <Dropdown
              type="link"
              className={styles.dropdown_wrapper}
              getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
              trigger={['click']}
              dropdownRender={() => (
                <div className={styles.dropdown_menu_wrapper}>
                  <SwitchDate
                    activeKey={activeKey}
                    value={selectedDate}
                    setActiveKey={setActiveKey}
                    setValue={setSelectedDate}
                  />
                </div>
              )}
            >
              {dayjs(selectedDate).format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY')}
            </Dropdown>
          }
        >
          <EnergyStats activeKey={activeKey} selectedDate={selectedDate} />
        </CardBox>
      </div>

      {/* 用能占比 */}
      <div className={styles.section_pie}>
        <CardBox title="用能占比" titleType="simple">
          <DeviceTypePie activeKey={activeKey} selectedDate={selectedDate} />
        </CardBox>
      </div>

      {/* 用能趋势 */}
      <div className={styles.section_trend}>
        <CardBox title="用能趋势" titleType="simple">
          <EnergyTrend />
        </CardBox>
      </div>
    </div>
  );
};

export default LeftBox;
